import { parseBool } from '@/utils/parse-functions';

const MinutesToMS = 60000;

let userAutoLogOffPlugin = store => {
	window.addEventListener(
		'keyup',
		() => autoLogoffManager.setLastActivity(),
		{ passive: true }
	);
	window.addEventListener(
		'mouseup',
		() => autoLogoffManager.setLastActivity(),
		{ passive: true }
	);
	window.addEventListener(
		'visibilitychange',
		() =>
			document.visibilityState !== 'hidden'
				? autoLogoffManager.checkLogoff()
				: autoLogoffManager.setLastActivity(),
		{ passive: true }
	);
	store.subscribe(function(mutation) {
		if (mutation.type === 'user/SetAppConfigs') {
			let payload = mutation.payload;
			let timeout = parseInt(payload.VUE_APP_AUTOLOGOFF_TIMEOUT);
			let enabled = parseBool(payload.VUE_APP_AUTOLOGOFF_ENABLED);
			autoLogoffManager.setConfiguration(timeout, enabled);
		}
	});
};

const autoLogoffManager = {
	storageKey: 'vue_auto_lastActivity',
	isEnabled: false,
	intervalId: undefined,
	interval: MinutesToMS,
	timeout: MinutesToMS * 60,
	currentTimeSpan: () => new Date().getTime(),
	getLastActivity() {
		let val = localStorage.getItem(this.storageKey);
		let time;

		if (val) {
			val = parseInt(val);
			time = new Date(val).getTime();
		}

		return time;
	},
	setLastActivity() {
		localStorage.setItem(this.storageKey, this.currentTimeSpan());
	},
	stopInterval() {
		if (this.intervalId != undefined) {
			clearInterval(this.intervalId);
			this.intervalId = undefined;
		}
	},
	startInterval() {
		if (this.intervalId || !this.isEnabled) return;
		this.intervalId = setInterval(
			this.checkLogoff.bind(this),
			this.interval
		);
	},
	checkLogoff() {
		if (
			this.isEnabled &&
			this.currentTimeSpan() > this.getLastActivity() + this.timeout
		) {
			window.dispatchEvent(new Event('vuelogout'));
		}
	},
	setConfiguration(newTimeout, enabled) {
		this.setLastActivity();
		this.timeout = newTimeout || MinutesToMS * 60;
		this.isEnabled = enabled || false;
		this.stopInterval();
		this.startInterval();
	}
};

export default [userAutoLogOffPlugin];
export { autoLogoffManager as AutoLogoffManager };
